<template>
    <div :class="$style.content">
        <div :class="$style.header">
            <!--<i @click="$router.push('/SupplyChain')" class="el-icon-back"></i>-->
            <div> </div>
            <h2>添加商品</h2>
            <el-input placeholder="请输入型号" v-model="keyword">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <div :class="$style.content_header">
            <div>
                <span style="display:inline-block;">全部类别</span>
                <el-button-group>
                    <el-button
                        v-for="{id, name, cat_id} in navigatorList"
                        :key="id"
                        @click="chossefirst(id,cat_id)"
                        :class="{[$style.chosen]: currNavigator === id }"
                    >
                        {{name}}
                    </el-button>
                </el-button-group><br>
                <span>二级类别</span>
                <el-button-group>
                    <el-button
                        v-for="{id, name} in filterList"
                        :key="id"
                        @click="currNavigator=id"
                        :class="{[$style.chosen]: currNavigator === id }"
                    >
                        {{name}}
                    </el-button>
                </el-button-group>

            </div>
            <!-- <div v-for="{filter_attr_name, attr_list} in filterList" :key="filter_attr_name">
                <span>{{filter_attr_name}}</span>
                <el-button-group>
                    <el-button
                        v-for="{attr_value_id, attr_value} in attr_list"
                        :key="attr_value_id"
                        :class="{ [$style.chosen]: currFilter === attr_value_id }"
                        @click="currFilter=attr_value_id"
                    >
                        {{attr_value}}
                    </el-button>
                </el-button-group>
            </div> -->
            <div>
                <span>综合</span>
                <el-button
                    v-for="{name, id} in sortList"
                    :key="id"
                    :class="{ [$style.chosen]: currSort === id }"
                    @click="currSort!==id?currSort=id:currOrder=currOrder==='DESC'?'ASC':'DESC'"
                >
                    {{name}}
                    <svg v-show="currSort === id && currOrder === 'DESC'" :class="$style.icon" aria-hidden="true">
                        <use xlink:href="#icon-xia"></use>
                    </svg>
                    <svg v-show="currSort === id && currOrder === 'ASC'" :class="$style.icon" aria-hidden="true">
                        <use xlink:href="#icon-shang"></use>
                    </svg>
                </el-button>
            </div>
        </div>
        <div :class="$style.table">
            <el-table :data="this.$store.state.productList">
                <el-table-column min-width="30%" label="商品">
                    <template slot-scope="scope">
                        <div :class="$style.product">
                            <img :src="scope.row.goods_thumb" alt="">
                            <span>{{scope.row.goods_name}}</span>
                        </div>
                    </template>
                </el-table-column>
               <!--  <el-table-column min-width="20%" label="单价" prop="shop_price">
                </el-table-column> -->
                <el-table-column min-width="20%" label="单价" prop="shop_price"
                                 :formatter="(row) => '￥'+ row.shop_price.toFixed(2)">
                </el-table-column>
                <!--<el-table-column min-width="20%" label="数量" prop="amount">-->
                    <!--<template slot-scope="scope">-->
                        <!--<el-input-number v-model="scope.row.amount" size="small" :min="0"></el-input-number>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column min-width="20%" label="金额">-->
                    <!--<template slot-scope="scope">-->
                        <!--<span :style="{color:  (scope.row.shop_price * scope.row.amount)===0? '#f74845': '#f74845'}">-->
                            <!--￥{{(scope.row.shop_price * scope.row.amount).toFixed(2)}}-->
                        <!--</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column min-width="20%" label="总库存" prop="goods_number"></el-table-column>
                <el-table-column min-width="20%" label="">
                    <template slot-scope="scope">
                        <Dialog
                            :goods_attr_list="scope.row.goods_attr_list"
                            :goods_id="scope.row.goods_id"
                            :getCartProducts="getCartProducts"
                        >
                            <el-button size="mini" @click="goodst(scope.row.goods_attr_list)">添加</el-button>
                        </Dialog>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="pages.page"
                :page-size="100"
                :total="Number(pages.record_count)"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import { getProducts, host } from '../../stores/api';
    import Vue from 'vue';
    import Dialog from './Dialog.vue';

    Vue.component('Dialog', Dialog);
    const sortList = [{
        id: 'is_hot',
        name: '热销',
    }, {
        id: 'shop_price',
        name: '价格',
    }, {
        id: 'last_update',
        name: '新品',
    }];
    export default {
        props: ['getCartProducts'],
        data () {
            return {
                sortList,
                productList: [],
                navigatorList: [],          //一级分类
                filterList: [],             //二级分类
                pages: {record_count: 0, page: 1},
                currNavigator: '1259',           //0全部
                currFilter: 0,              //0全部
                currSort: 'is_hot',
                currOrder: 'DESC',          //'DESC'箭头往下，正序，'ASC'反之
                options: [],
                names: '',
                keyword: '',
            }
        },
        created () {
            this.getProducts();
        },
        methods: {
            async getProducts (params) {
                const {
                    currNavigator: id,
                    currFilter: filter_attr,
                    currSort: sort,
                    currOrder: order,
                } = this;
                return getProducts(Object.assign({id, page: 1, filter_attr, sort, order,keyword:''}, params)).then(res => {
                    let {navigator_list, goods_list, filter_attr, pages} = res.data;
                    //navigator_list.unshift({
                       //  name: '全部',
                        // cid: 0,
                        // url: 'supply.php?id=0',
                     //});
                    goods_list = goods_list.map(item => {
                        let {goods_thumb, shop_price} = item;
                        shop_price = Number(shop_price.replace('￥', '').replace('元', ''));
                        goods_thumb = host + '/' + goods_thumb;
                        return Object.assign(item, {amount: 0, goods_thumb, shop_price});
                    });
                    //this.productList = goods_list;
                    console.log(res)
                    this.$store.state.productList = goods_list
                    this.navigatorList = navigator_list;
                    console.log(this.navigatorList)
                    if (this.currNavigator === '1259') {
                        this.filterList = navigator_list[1259].cat_id;
                    }
                    // console.log(navigator_list[1259].car_id)
                    this.pages = pages;
                });
            },
            async getProducts1 (params) {
                const {
                    currNavigator: id,
                    currFilter: filter_attr,
                    currSort: sort,
                    currOrder: order,
                } = this;
                return getProducts(Object.assign({id:'', page: 1, filter_attr, sort, order, keyword: this.keyword}, params)).then(res => {
                    let {navigator_list, goods_list, filter_attr, pages,} = res.data;
                    //navigator_list.unshift({
                    //  name: '全部',
                    // cid: 0,
                    // url: 'supply.php?id=0',
                    //});
                    goods_list = goods_list.map(item => {
                        let {goods_thumb, shop_price} = item;
                        shop_price = Number(shop_price.replace('￥', '').replace('元', ''));
                        goods_thumb = host + '/' + goods_thumb;
                        return Object.assign(item, {amount: 0, goods_thumb, shop_price});
                    });
                    //this.productList = goods_list;
                    console.log(res)
                    this.$store.state.productList = goods_list
                    this.navigatorList = navigator_list;
                    console.log(this.navigatorList)
                    if(this.currNavigator=='1259'){
                        this.filterList = navigator_list[1259].cat_id;
                    }
                    // console.log(navigator_list[1259].car_id)
                    this.pages = pages;
                    this.pageSize = pages.size
                });
            },

            pageChange (val) {
                this.getProducts({page: val});
            },
            //一级选择
            chossefirst(id, cat_id) {
                this.currNavigator = id
                this.filterList = cat_id
            },
            goodst(item) {
                console.log(item)
            }
        },
        watch: {
            keyword() {
                this.getProducts1()
            },
            currNavigator (val) {
                //重置分类
                this.filter_attr = 0;
                this.getProducts();
            },
            currFilter (val) {
                this.getProducts();
            },
            currSort (val) {
                this.getProducts();
            },
            currOrder (val) {
                this.getProducts();
            }
        }
    };
</script>

<style lang="less" module>
    @import '../../default';
    .content {
        .header {
            display: flex;
            align-items: center;
            font-size: 16px;
            & > i {
                flex: 0.3;
                color: rgba(156, 162, 173, 0.68);
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
                &:hover {
                    color: #9ca2ad;
                }
            }
            & > h2 {
                flex: 0.4;
                text-align: center;
            }
            & > div {
                flex: 0.3;
            }
        }
        .content_header {
            padding: 8px;
            margin-bottom: 30px;
            background: #f2f4f5;
            font-size: 16px;
            & > div {
                margin: 0 32px;
                padding: 16px 0;
                border-bottom: 1px solid #d8dde6;
                & > span {
                    width: 80px;
                    font-size: 14px;
                    display: inline-block;
                    color: #9ca2ad;
                }
                button {
                    min-width: 75px;
                    height: 30px;
                    margin-right: 8px;
                    padding: 0 10px;
                    background: transparent;
                    border-radius: 0;
                    border: 1px solid transparent;
                    font-size: 14px;
                    color: #1f2329;
                    &:hover {
                        .chosen;
                    }

                    .icon {
                        width: 10px;
                        height: 15px;
                        fill: @orange;
                        vertical-align: middle;
                    }
                }
                .chosen {
                    color: @orange;
                    border-color: @orange;
                }
            }

            & > div:last-child {
                border-bottom: 0;
                button {
                    margin: 0;
                    border: 0;
                    &:after {
                        display: none !important;
                    }
                }
            }
        }

        .table {
            border: 1px solid #d8dde6;

            th, td {
                padding: 12px 0;
                vertical-align: top;
                :global {
                    .cell {
                        font-size: 14px;
                        text-align: center;

                        .el-input-number {
                            width: 120px;
                            input {
                                border-radius: 0;
                                padding: 0 39px;
                            }
                        }
                        .el-input-number__increase, .el-input-number__decrease {
                            width: 32px;
                        }
                    }
                }

                .product {
                    display: flex;
                    text-align: left;
                    img {
                        width: 90px;
                        height: 90px;
                        margin: 0 15px;
                        border: 1px solid #dee0e0;
                    }
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/AddPro/Content.vue